module.exports = __webpack_public_path__ + "img/Line.cc9487c1.svg";